"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var sis_tabular_report_table_header_component_1 = require("./sis-tabular-report-table-header/sis-tabular-report-table-header.component");
var sis_tabular_report_designer_component_1 = require("./sis-tabular-report-designer.component");
var sis_tabular_report_rows_panel_component_1 = require("./sis-tabular-report-rows-panel/sis-tabular-report-rows-panel.component");
var sis_tabular_report_row_component_1 = require("./sis-tabular-report-rows-panel/sis-tabular-report-row/sis-tabular-report-row.component");
var sis_material_module_1 = require("../modules/sis-material-module");
var view_event_service_1 = require("./service/view-event.service");
var dataset_container_1 = require("./service/dataset-container");
var common_1 = require("@angular/common");
var sis_dnd_directive_1 = require("./dnd/sis-dnd.directive");
var sis_tabular_report_options_component_1 = require("../sis-tabular-report-options/sis-tabular-report-options.component");
var sis_tabular_report_invalid_state_module_1 = require("../invalid-state/sis-tabular-report-invalid-state.module");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var reporting_pipes_module_1 = require("../pipes/reporting-pipes.module");
var idm_reporting_controls_1 = require("@synisys/idm-reporting-controls");
var boolean_operator_names_factory_1 = require("../sis-tabular-report-options/conditional-formatting/boolean-operator-names-factory");
var condition_text_generator_service_1 = require("../sis-tabular-report-options/conditional-formatting/condition-text-generator-service");
var branchindex_measurepathholder_ids_creator_1 = require("../sis-tabular-report-options/conditional-formatting/branchindex-measurepathholder-ids-creator");
var measure_type_resolver_service_1 = require("../sis-tabular-report-options/service/measure-type-resolver.service");
var sis_column_formatting_component_1 = require("../sis-tabular-report-options/conditional-formatting/column-formatting/sis-column-formatting.component");
var sis_text_style_component_1 = require("../sis-tabular-report-options/conditional-formatting/text-style/sis-text-style.component");
var sis_row_formatting_component_1 = require("../sis-tabular-report-options/conditional-formatting/row-formatting/sis-row-formatting.component");
// tslint:disable:max-line-length
var sis_column_formatting_rules_listing_component_1 = require("../sis-tabular-report-options/conditional-formatting/column-formatting-rules-listing-component/sis-column-formatting-rules-listing-component");
var sis_row_formatting_rules_listing_component_1 = require("../sis-tabular-report-options/conditional-formatting/row-formatting-rules-listing-component/sis-row-formatting-rules-listing-component");
var recommendation_service_1 = require("../service/recommendation-service");
var http_recommendation_service_1 = require("../service/http-recommendation-service");
var report_recommendations_helper_1 = require("./service/report-recommendations-helper");
var idm_currency_rate_frontend_1 = require("@synisys/idm-currency-rate-frontend");
var sanitize_pipe_1 = require("../pipes/sanitize.pipe");
require("@synisys/synergy-design-system");
// tslint:enable:max-line-length
var SisTabularReportDesignerModule = /** @class */ (function () {
    function SisTabularReportDesignerModule() {
    }
    SisTabularReportDesignerModule = __decorate([
        core_1.NgModule({
            declarations: [
                sis_tabular_report_designer_component_1.SisTabularReportDesignerComponent,
                sis_tabular_report_options_component_1.SisTabularReportOptionsComponent,
                sis_tabular_report_rows_panel_component_1.SisTabularReportRowsPanelComponent,
                sis_tabular_report_table_header_component_1.SisTabularReportTableHeaderComponent,
                sis_tabular_report_row_component_1.SisTabularReportRowComponent,
                sis_dnd_directive_1.SisDndDirective,
                sis_text_style_component_1.SisTextStyleComponent,
                sis_column_formatting_rules_listing_component_1.SisColumnFormattingRulesListingComponent,
                sis_row_formatting_rules_listing_component_1.SisRowFormattingRulesListingComponent,
                sis_column_formatting_component_1.SisColumnFormattingComponent,
                sis_row_formatting_component_1.SisRowFormattingComponent
            ],
            imports: [
                forms_1.FormsModule,
                common_1.CommonModule,
                sis_material_module_1.SisMaterialModule,
                sis_tabular_report_invalid_state_module_1.SisTabularReportInvalidStateModule,
                idm_ng_controls_1.ControlsModule,
                reporting_pipes_module_1.ReportingPipesModule,
                idm_reporting_controls_1.ReportingControlsModule,
                idm_currency_rate_frontend_1.SisCurrencyComboModule
            ],
            providers: [
                view_event_service_1.ViewEventService,
                dataset_container_1.DatasetContainer,
                boolean_operator_names_factory_1.BooleanOperatorNamesFactory,
                condition_text_generator_service_1.ConditionTextGeneratorService,
                branchindex_measurepathholder_ids_creator_1.BranchIndexMeasurePathHolderIdsCreator,
                measure_type_resolver_service_1.MeasureTypeResolverService,
                report_recommendations_helper_1.ReportRecommendationsHelper,
                { provide: recommendation_service_1.RecommendationService, useClass: http_recommendation_service_1.HttpRecommendationService },
                sanitize_pipe_1.SanitizePipe
            ],
            exports: [
                sis_tabular_report_designer_component_1.SisTabularReportDesignerComponent,
                sis_tabular_report_options_component_1.SisTabularReportOptionsComponent,
                sis_text_style_component_1.SisTextStyleComponent,
                sis_column_formatting_rules_listing_component_1.SisColumnFormattingRulesListingComponent,
                sis_row_formatting_rules_listing_component_1.SisRowFormattingRulesListingComponent,
                sis_column_formatting_component_1.SisColumnFormattingComponent,
                sis_row_formatting_component_1.SisRowFormattingComponent
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
        })
    ], SisTabularReportDesignerModule);
    return SisTabularReportDesignerModule;
}());
exports.SisTabularReportDesignerModule = SisTabularReportDesignerModule;
//# sourceMappingURL=sis-tabular-report-designer.module.js.map